import globals from '@/globals';

const I = globals.I || { gt: { __: (str) => str } };

const ENG = {
  ok: I.gt.__('OK'),
  no: I.gt.__('No'),
  yes: I.gt.__('Yes'),
  all: I.gt.__('All'),
  name: I.gt.__('Name'),
  description: I.gt.__('Description'),
  size: I.gt.__('Size'),
  source: I.gt.__('Source'),
  delete: I.gt.__('Delete'),
  create: I.gt.__('Create'),
  cancel: I.gt.__('Cancel'),
  clear: I.gt.__('Clear'),
  clearAll: I.gt.__('Clear all'),
  apply: I.gt.__('Apply'),
  close: I.gt.__('Close'),
  info: I.gt.__('Info'),
  metaviewer: I.gt.__('Metaviewer'),
  differences: I.gt.__('Differences'),
  viewVariants: I.gt.__('View variants'),
  listVariants: I.gt.__('List of Variants'),
  customize: I.gt.__('Customize'),
  details: I.gt.__('Details'),
  preview: I.gt.__('Preview'),
  references: I.gt.__('References'),
  trackChanges: I.gt.__('Track Changes'),
  publishStatus: I.gt.__('Publish Status'),
  status: I.gt.__('Status'),
  publish: I.gt.__('Publish'),
  manually: I.gt.__('Manually'),
  inWorkflow: I.gt.__('In workflow'),
  inArchive: I.gt.__('In archive'),
  publishDocuments: I.gt.__('Publish Documents'),
  unpublish: I.gt.__('Unpublish'),
  scheduledForPublishing: I.gt.__('Scheduled for publishing'),
  publishedToLiveServer: I.gt.__('Published to live server'),
  reimport: I.gt.__('Re-import'),
  republish: I.gt.__('Republish'),
  unpublishDocuments: I.gt.__('Unpublish Documents'),
  reparse: I.gt.__('Reparse'),
  edit: I.gt.__('Edit'),
  desktop: I.gt.__('Desktop'),
  save: I.gt.__('Save'),
  continue: I.gt.__('Continue'),
  back: I.gt.__('Back'),
  confirm: I.gt.__('Confirm'),
  history: I.gt.__('History'),
  slideshow: I.gt.__('Slideshow'),
  quickedit: I.gt.__('Quickedit'),
  zoom: I.gt.__('Zoom'),
  insert: I.gt.__('Insert'),
  insertVariant: I.gt.__('Insert variant'),
  confirmation: I.gt.__('Confirmation'),
  moreOptions: I.gt.__('More Options'),
  queryMode: I.gt.__('Query-Mode'),
  search: I.gt.__('Search'),
  searchFor: I.gt.__('Search for...'),
  searchInDocuments: I.gt.__('Search in Documents'),
  searchInMedia: I.gt.__('Search in Media Files'),
  savedSearchFilters: I.gt.__('Saved Search Filters'),
  theFilterWasSaved: I.gt.__('The filter was saved successfully'),
  thereIsAlreadyAFilter: I.gt.__('There is already a filter with the chosen name. Please choose a different name.'),
  searchOptions: I.gt.__('Search in Options'),
  searchFilters: I.gt.__('Search filters'),
  addOrRemoveFiltersOption: I.gt.__('Add or Remove Filter Options'),
  filterName: I.gt.__('Filter name'),
  filterInputNotValid: I.gt.__('Please enter only letters and numbers'),
  noObjectSelected: I.gt.__('No object selected'),
  clickOnAnyItemToViewTheDetails: I.gt.__('Click on any item to view the details'),
  before: I.gt.__('before'),
  after: I.gt.__('after'),
  upToDateStatus: I.gt.__('Up to date'),
  notAvailable: I.gt.__('Not available'),
  unpublished: I.gt.__('Unpublished'),
  updatePending: I.gt.__('Update Pending'),
  updateScheduled: I.gt.__('Update scheduled'),
  updateAvailable: I.gt.__('Update available'),
  of: I.gt.__('of'),
  loading: I.gt.__('Loading'),
  opensBlank: I.gt.__('(opens in a new window)'),
  previewOpensBlank: I.gt.__('Preview (opens in a new window)'),
  finished: I.gt.__('finished'),
  multiactionToolbar: I.gt.__('Multiaction Toolbar'),

  addRecommendation: I.gt.__('Add Recommendation'),
  removeRecommendation: I.gt.__('Remove Recommendation'),
  recommended: I.gt.__('Recommended'),
  showDocuments: I.gt.__('Show Documents'),
  currentPage: I.gt.__('Current Page'),

  columns: I.gt.__('Columns'),
  filters: I.gt.__('Filters'),
  setFilter: I.gt.__('Set Filter'),
  setDefault: I.gt.__('Set to Default'),
  clearFilter: I.gt.__('Clear Filter'),
  manageFilters: I.gt.__('Manage Filters'),
  categories: I.gt.__('Categories'),
  directories: I.gt.__('Directories'),
  variants: I.gt.__('Variants'),
  previews: I.gt.__('Previews'),
  setFocusPoint: I.gt.__('Set Focus Point'),
  focusPoint: I.gt.__('Focus Point'),

  noItems: I.gt.__('The are no items available'),

  // Menu
  mainMenu: I.gt.__('Main menu'),

  // Browser
  documentBrowser: I.gt.__('Document Browser'),
  mediaManagement: I.gt.__('Media Management'),
  createNewDocument: I.gt.__('Create new document'),
  createCategory: I.gt.__('Create category'),
  editCategory: I.gt.__('Edit category'),
  archive: I.gt.__('Archive'),
  deleteCategory: I.gt.__('Delete category'),
  expandCategories: I.gt.__('Expand categories'),
  upload: I.gt.__('Upload'),
  multiupload: I.gt.__('Multiupload'),
  import: I.gt.__('Import'),
  showArchive: I.gt.__('Show Archive'),
  noContent: I.gt.__('No content'),
  saveFilter: I.gt.__('Save filter'),
  documentInfo: I.gt.__('Document Info'),
  allCategories: I.gt.__('All categories'),
  includingSubcategories: I.gt.__('Including subcategories'),
  allDirectories: I.gt.__('All directories'),
  includingSubdirectories: I.gt.__('Including subdirectories'),
  searchInTree: I.gt.__('Search for category/directory'),
  categoryTree: I.gt.__('Category Tree'),
  checkboxDefaultAriaLabel: I.gt.__('Select'),
  moreOptionsLabel: I.gt.__('More options'),
  hiddenOptionsWarning: I.gt.__('Not all options are displayed. Use the search to find more options.'),
  referencesOf: I.gt.__('References of '),
  notReferenced: I.gt.__('Not referenced '),
  noReferences: I.gt.__('No references'),
  usedBy: I.gt.__('Used by'),
  viewContent: I.gt.__('View content'),
  selectTargetSystem: I.gt.__('Select Target system'),
  noResultsMatched: I.gt.__('No results matched'),
  information: I.gt.__('Information'),
  basicMode: I.gt.__('Basic Mode'),
  advancedSearch: I.gt.__('Advanced Search'),
  startDateFrom: I.gt.__('Start date (from)'),
  endDateTill: I.gt.__('End date (till)'),
  browseBy: I.gt.__('Browse by'),
  clickOnCategory: I.gt.__('Click on a Category to show its Documents.'),
  documentCountError: I.gt.__('There was a problem loading the documents!'),
  entriesFound: I.gt.__('entries found'),
  entryFound: I.gt.__('entry found'),
  showEntireList: I.gt.__('Show entire list'),

  // Columns
  actions: I.gt.__('Actions'),
  select: I.gt.__('Select'),
  lastFinished: I.gt.__('Last finished'),
  publishedAt: I.gt.__('Published at'),
  published: I.gt.__('Published'),
  publishDate: I.gt.__('Publish date'),
  expiryDate: I.gt.__('Expiry date'),
  resubmitDate: I.gt.__('Resubmit date'),
  createdBy: I.gt.__('Created by'),
  lastEditor: I.gt.__('Last editor'),
  firstCreatedDate: I.gt.__('First created date'),
  category: I.gt.__('Category'),
  icon: I.gt.__('Icon'),
  liveURI: I.gt.__('Live URI'),

  today: I.gt.__('today'),
  yesterday: I.gt.__('yesterday'),
  last3days: I.gt.__('last 3 days'),
  last7days: I.gt.__('last 7 days'),
  last30days: I.gt.__('last 30 days'),
  inThePast: I.gt.__('in the past'),
  customDates: I.gt.__('custom'),

  selectAllDocuments: I.gt.__('Not all available documents were selected, only the currently loaded'),

  // Details
  title: I.gt.__('Title'),
  nodeId: I.gt.__('Node ID'),
  directory: I.gt.__('Directory'),
  filename: I.gt.__('Filename'),
  uri: I.gt.__('URI'),
  template: I.gt.__('Template'),
  filesize: I.gt.__('Filesize'),
  dimensions: I.gt.__('Dimensions'),
  metaPage: I.gt.__('Meta page'),
  upToDate: I.gt.__('Up-to-date'),
  generatedPages: I.gt.__('Generated Pages'),
  publishingDate: I.gt.__('Publishing Date'),
  notPublished: I.gt.__('Not published'),
  publishedPagesAndServers: I.gt.__('Published pages and servers'),
  workflowStatus: I.gt.__('Workflow Status'),
  publishingState: I.gt.__('Publishing State'),
  metaInfo: I.gt.__('Meta info'),

  // References Modal
  linkedDocumentsAndInsetedImages: I.gt.__('Linked Documents and Inserted Images'),
  documentsReferencingThisMediaFile: I.gt.__('Documents referencing this Media File'),
  documentsReferencingThisDocument: I.gt.__('Documents referencing this Document'),
  action: I.gt.__('Action'),
  type: I.gt.__('Type'),

  // Variants Modal
  defaultImage: I.gt.__('Default Image to be inserted'),

  // Tag specific
  tagName: I.gt.__('Enter Tags'),
  tagRealms: I.gt.__('Tag Realms'),
  realmName: I.gt.__('Enter Name'),
  createTag: I.gt.__('Create new Tag'),
  createTags: I.gt.__('Create new Tags'),
  createRealm: I.gt.__('Create new Realm'),
  deleteRealm: I.gt.__('Delete'),
  noTagRealmsHint: I.gt.__('No Tag Realms found'),
  noTagsHint: I.gt.__('No Tags found'),
  clickOnRealmHint: I.gt.__('Click on a Tag Realm to edit its Tags'),
  chosenTagHelpText: I.gt.__('Type in a tag and press ENTER to apply it'),
  tagInputNotValid: I.gt.__('The following characters are not allowed: [ , | \ / < > " \' ]'), // eslint-disable-line
  realmInputNotValid: I.gt.__('Please enter only letters and numbers'),
  tagAlreadyExists: I.gt.__('Tag already exists'),

  tagAddedRecommendedMsg: I.gt.__('The Tag has been added to the Recommendations'),
  tagRemovedRecommendedMsg: I.gt.__('The Tag has been removed from the Recommendations'),

  // Confirmations
  confirmDeleteTag: I.gt.__('Are you sure you want to delete this tag?'),
  confirmDeleteRealm: I.gt.__('Are you sure you want to delete this realm?'),
  confirmDeleteFilter: I.gt.__('Are you sure you want to delete this filter?'),
  confirmUnpublishDocuments: I.gt.__('Do you want to unpublish the selected documents?'),
  confirmPublishDocuments: I.gt.__('Do you want to publish the selected documents?'),

  successfullyDeletedUserSettings: I.gt.__('Successfully deleted user settings!'),
  documentBrowserConfiguration: I.gt.__('Document browser configuration'),
  mediaAssetManagementConfiguration: I.gt.__('Media Asset Management configuration'),
  deleteConfigurationConfirm: I.gt.__('Are you sure you want to delete configuration'),

  // Differences modal
  mode: I.gt.__('Mode'),
  versionFilter: I.gt.__('Version Filter'),
  openSlideshow: I.gt.__('Open Slideshow'),
  count: I.gt.__('Count'),

  // Drag and Drop zone
  dropYourFilesHereToStartUploading: I.gt.__('Drop your files here to start uploading'),
  thinkTwiceBeforeUploadingBigFiles: I.gt.__('Think twice before uploading big files'),
  fileUpload: I.gt.__('File upload'),

  storedSettings: I.gt.__('Stored Settings'),
  deleteFile: I.gt.__('Delete File'),

  rootCatTitle: I.gt.__('Root Category'),
  rootCatMissing: I.gt.__('No root category found.'),
  rootCatCreate: I.gt.__('Do you want to create a new root category?'),
  rootCatMissingMam: I.gt.__('No asset enabled category found.'),
  rootCatCreateMam: I.gt.__('Do you want to create an asset-enabled category?'),

  // Copy documents
  copy: I.gt.__('Copy'),
  copying: I.gt.__('Copying'),
  copied: I.gt.__('Copied'),
  paste: I.gt.__('Paste'),
  notAllowed: I.gt.__('Not Allowed'),
  copyingNotAllowed: I.gt.__('Copying not allowed'),
  documentsCopied: I.gt.__('documents were copied.'),
  cancelPasting: I.gt.__('Cancel pasting'),
  confirmCancelPasting: I.gt.__('Do you wish to cancel the pasting?'),

  // Change publishdate/expirydate/resubmitdate
  changeDates: I.gt.__('Change dates'),
  processingDates: I.gt.__('Processing dates'),
  noDocumentTitle: I.gt.__('No title'),
  cantEditDoc: I.gt.__('Cannot edit this document'),
  scheduled: I.gt.__('Scheduled'),
  markForDeletion: I.gt.__('Mark for deletion'),
  markedForDeletion: I.gt.__('Marked for deletion'),
  next: I.gt.__('Next'),
  checkToEdit: I.gt.__('Check the box to edit this field'),
  undo: I.gt.__('Undo'),

  // Fetch Service

  responeReturnedStatusCode: I.gt.__('Response returned status code'),
  tooManyFiles: I.gt.__('Error: Too many files. Try again with less files.'),
  rejectedReason: I.gt.__('Rejected reason'),

  // Placeholders for I.gt.__x

  documentCounterPlaceholder: I.gt.__x('{validDocuments} of {totalDocuments} documents', {
    validDocuments: 1,
    totalDocuments: 2,
  }),
  uploadWarningPlaceholder: I.gt.__x('Warning {invalid} out {total} media files are not valid', {
    invalid: 1,
    total: 2,
  }),
  fileMimeTypePlaceholder: I.gt.__x('{type} file', {
    type: 'html',
  }),

  // Chosen
  chosenInputNotValid: I.gt.__('The following characters are not allowed: [ , | \ / < > " \' ]'), // eslint-disable-line
  chosenPlaceholder: I.gt.__('Enter items'),
  chosenHelpText: I.gt.__('Type in an item and press ENTER to apply it'),
  chosenItemAlreadyExists: I.gt.__('Item already exists'),
};
// export default ENG;
export default JSON.parse(JSON.stringify(ENG));
